import { apiRequest } from './index';

export const fetchAttendanceRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/attendances/' + id, {}, success, failure);
}

export const fetchAttendancesRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/attendances', {}, success, failure);
}

export const fetchAttendancesByEmployeeRequest = ( { employeeId, startDate, endDate }, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(`/attendances/by-employee/${employeeId}?startDate=${startDate}&endDate=${endDate}`, {}, success, failure);
}

export const createAttendanceRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/attendances',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editAttendanceRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/attendances/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const deleteAttendanceRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/attendances/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}

export const handleAttendanceCSVRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/attendances/csv',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}
